// Light/dark theme, toggled via a `dark` class on <html> and remembered in
// localStorage. Defaults to light on first visit.
import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

const getInitial = () => {
  try {
    return localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitial);
  const dark = theme === 'dark';

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    try { localStorage.setItem('theme', theme); } catch { /* ignore */ }
  }, [theme, dark]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, dark, toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
